<template>
  <el-dialog class="dialog-create-plan" :title="pageType==='add' ?'信息发布':'编辑信息发布'" :visible.sync="dialogVisible" :before-close="handleBeforeClose" width="850px">
    <div class="wrap">
      <el-form class="g-form-grid" ref="form" :model="form" label-width="120px" :rules="rules">
        <el-form-item label="通知公告标题 :" prop="title">
          <el-input v-model="form.title" placeholder="请输入" :disabled="pageType==='detail' || pageType==='approval'"></el-input>

        </el-form-item>

        <el-form-item label="通知公告类型 :" prop="type">

          <el-select v-model="form.type" :disabled="pageType==='detail' || pageType==='approval'" placeholder="请选择">
            <el-option v-for="item in typeList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode">
            </el-option>
          </el-select>

        </el-form-item>

        <el-form-item label="接受人群:" prop="scope">
          <el-radio-group v-model="form.scope">
            <el-radio v-for="item in scopeList" :label="item.dictCode" :key="item.dictCode">{{item.dictName}}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="内容 :" prop="content">
          <cmp-ckeditor ref="myCkeditor" :defaultMsg="form.content"  :id="`ue1`" :height="300"></cmp-ckeditor>
        </el-form-item>

        <el-form-item label="附件 :">
          <!-- 上传 -->
          <cmpUploadProgress ref="cmpUploadProgress" :callFun="uploadCallback" :showUpload="pageType==='detail' || pageType==='approval'?false:true" :showTip="pageType==='detail' || pageType==='approval'?false:true" :fileList="form.attachmentList" :accept="`.rar, .zip, .doc, .docx, .pdf, .jpg`"></cmpUploadProgress>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="footer mt-30" v-if="pageType!=='detail'">
      <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">发布</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { validate } from '@/utils/util'
import cmpUploadProgress from '@cmp/my-upload/upload-progress' // 上传组件
import cmpCkeditor from '@cmp/editor/ckeditor'
export default {
  components: {
    cmpUploadProgress,
    cmpCkeditor
  },
  data() {
    // let validateReceiptNumber = (rule, value, callback) => {
    //   if (!validate(value, 'numDecimal')) {
    //     return callback(new Error('最多支持两位小数'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      loadingSave: false,
      pageType: 'add', // 页面类型 add 新增  edit 编辑  detail 详情
      detailId: '', // 用户id
      form: {
        attachmentList: []
      },
      typeList: [],
      dialogVisible: false,
      rules: {
        scope: [
          { required: true, message: '必填', trigger: 'blur' },
          // { min: 1, max: 30, message: '请输入1到30个字符', trigger: 'blur' }
        ],
        title: [{ required: true, message: '必填', trigger: 'blur' }],
      },
      scopeList: [],
      // 工具栏自定义配置https://www.geek-share.com/detail/2633938103.html
      toolbarConfig: [
        // { name: 'document', items : [ 'Source','-','Save','NewPage','DocProps','Preview','Print','-','Templates' ] },  
        { name: 'clipboard', items : ['Undo','Redo' ] },  
        // { name: 'editing', items : [ 'Find','Replace','-','SelectAll','-','SpellChecker', 'Scayt' ] },  
        // { name: 'forms', items : [ 'Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton',  
        // 'HiddenField' ] },  
        // '/',  
        { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'RemoveFormat'] },
        {
          name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote',
            '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl']
        },
        // { name: 'paragraph', items : [ 'NumberedList','BulletedList','-','Outdent','Indent','-','Blockquote','CreateDiv',  
        // '-','JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock','-','BidiLtr','BidiRtl' ] },  
        { name: 'links', items: ['Link', 'Unlink'] },
        // { name: 'links', items : [ 'Link','Unlink','Anchor' ] },  
        { name: 'insert', items: ['Image', 'Table'] },
        // { name: 'insert', items : [ 'Image','Flash','Table','HorizontalRule','Smiley','SpecialChar','PageBreak','Iframe' ] },  
        '/',
        { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
        { name: 'colors', items: ['TextColor', 'BGColor'] },
        { name: 'tools', items: ['Maximize', 'ShowBlocks', '-', 'About'] }
      ]
    }
  },
  methods: {
    init(type, id) {
      this.dialogVisible = true
      // 清空弹框数据
      this.form = { attachmentList: [] }
      this.pageType = type // 页面类型
      this.detailId = id || '' // 详情id
      // 新增或编辑
      if (this.detailId) {
        this.getDetailData()
      }
      this.getDropdownValue()
      this.$nextTick(() => {
        this.$refs.cmpUploadProgress.init() // 触发子组件上传组件方法
        this.$refs.myCkeditor.initEditor()
        this.$refs['form'].clearValidate() // 清空验证状态
      })
    },

    // 获取详情
    getDetailData() {
      this.$http
        .get('/bsInformation/find', {
          informationId: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.form = res.result
            this.form.attachmentList = res.result.fileList
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 获取下拉状态选择值
    getDropdownValue() {
      this.$http
        .post('/collectDict/getSelectDataByArr', { arr: ['information_type', 'information_scope'] })
        .then(res => {
          if (res.success) {
            var state = res.result
            let firstArr = []
            this.typeList = firstArr.concat(state['information_type'])
            this.scopeList = firstArr.concat(state['information_scope'])
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 文件上传回调
    uploadCallback(fileStr) {
      this.form.fileIds = fileStr
    },

    // 保存
    fromSubmit(form) {
      let content = this.$refs.myCkeditor.getContent() // 调用子组件方法
      if (!content) {
        this.$message.warning('请输入内容')
        return
      }
      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true
          this.$http
            .post('/bsInformation/save', {
              ...this.form,
              content: content
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                if (this.pageType === 'edit') {
                  this.$message.success('信息发布编辑成功')
                } else if (this.pageType === 'add') {
                  this.$message.success('信息发布创建成功')
                }
                this.dialogVisible = false
                this.$emit('refresh')
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },

    // 取消
    cancel() {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    },

    handleBeforeClose(done) {
      this.$refs.myCkeditor.setContent('')  // 处理编辑时偶尔不能渲染出富文本数据
      done()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
